import { Box, TableCell, TableRow, Text } from '@ksyos/design-system';
import { useTheme } from 'styled-components';
import { EmptyFolderIcon } from '@frontend/components/elements/EmptyFolderIcon';
import { translateKey } from '@frontend/translate';

export function OutclinicDashboardTableNoResults() {
    const theme = useTheme();

    return (
        <TableRow>
            <TableCell
                colSpan={12}
                sx={{ backgroundColor: theme.colors.neutral50, padding: 7, position: 'relative' }}
            >
                <Box textAlign="center">
                    <EmptyFolderIcon
                        size={88}
                        style={{
                            marginBottom: 16,
                        }}
                    />
                    <Text
                        color="minimal"
                        size="sm"
                    >
                        {translateKey('outclinicDashboard.noResults')}
                    </Text>
                </Box>
            </TableCell>
        </TableRow>
    );
}
